<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="mac">
			<div class="mac-1">设备编号：{{macLeaveFactory.macCode}}</div>
			<div class="mac-1">设备类型：{{macLeaveFactory.macDetailsName}}</div>
		</div>
		<Table border :columns="columns12" :data="data6"  :loading="loading">
			<template slot-scope="{ row, index }" slot="action">
				<!-- <Button type="primary" size="small" style="margin-right: 5px" @click="update(row.id)">修改</Button> -->
				<!-- <Button type="primary" @click="update(row.id)">更换运营商</Button> -->
			</template>
		</Table>
		<div class="my-page">
			<page :total="total" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				macLeaveFactory:{},//设备信息
				total: 0,
				loading:false,
				query:{
					page:0,
					size:10,
					macId:'',//设备id
					/* id:''//加盟商id */
				},
				columns12: [
					{
						title: '图片',
						key: 'imgUrl',
						width: 136,
						render: (h, params) => {
							if(params.row.operComm.img!=null){
								return h('div', [
									h('img', {
										style: {
											width: "100px",
											height:'100px',
											verticalAlign: "middle"
										},
										attrs: {
											src: params.row.operComm.img
										}
									}, )
								]);
							}else{
								return h('div',"" );
							}
						}
					},{
						title: 'id',
						key: 'id'
					},
					{
						title: '编号',
						key: 'number'
					},
					{
						title: '运营商',
						key: 'operator',
						render: (h, params) => {
							if(params.row.operator.companyName==null){
								return h("div","")
							}else{
								return h("div",params.row.operator.companyName)
							}
						}
					},
					{
						title: '订单编号',
						key: 'operOrderId'
					},
					{
						title: '货道编号',
						key: 'number'
					},
					{
						title: '商品信息',
						key: 'operComm',
						render: (h, params) => {
							if(params.row.operComm==null){
								return h("div","暂无")
							}else{
								return h("div",params.row.operComm.name)
							}
						}
					},
					{
						title: '最大库存',
						key: 'maxNumber'
					},
					{
						title: '库存报警数',
						key: 'minNumber'
					},
					{
						title: '可出货数量',
						key: 'currentMayNumber'
					},
					{
						title: '待出货数量',
						key: 'currentNoMayNumber'
					},
					// {
					// 	title: '开始时间',
					// 	key: 'beginDateTime'
					// },
					// {
					// 	title: '结束时间',
					// 	key: 'overDateTime'
					// },
					// {
					// 	title: '到期天数',
					// 	key: 'isOver',
					// 	render: (h, params) => {
					// 		if(params.row.operator.companyName!=null){
					// 			if(params.row.isOver>=0){
					// 				if(params.row.isOver<10){
					// 					return h("div",{style:{color:'#D5D52B'}},params.row.isOver+"天")
					// 				}else{
										
					// 					return h("div",params.row.isOver+"天")
					// 				}
					// 			}else {
					// 				return h("div",{style:{color:'red'}},"已到期")
					// 			}
					// 		}else{
					// 			return h("div","")
					// 		}
							
					// 	}
						
					// },
					 {
						title: '操作',
						slot: 'action',
						width: 150,
						align: 'center'
					} 
				],
				data6: [{
					id: '',
					number: '',
					operator:''
				}]

			}
		},
		methods: {
			ret() { //返回上一页
				this.$router.go(-1)
			},
			
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			ajaxPage() {
				let _this=this
				this.loading = true
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/mac/leave/factory/aisle/page/jm/alliance',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.aisles.totalElements
						_this.data6 = data.aisles.content
						
						_this.loading = false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
			},
			queryById() {
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fac/mac/leave/factory/findById',
				    data: {id:_this.query.macId},
					_this: _this,
					success: function(data) {
						_this.macLeaveFactory=data.macLeaveFactory
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
			}

		},
		components: {
			page
		},
		created() {
			let macId=this.$route.query.id
		/* 	let allianceId=this.$route.query.allianceId */
			
			this.query.macId=macId
			/* this.query.id=allianceId */
			this.ajaxPage()
			this.queryById()
		}

	}
</script>
<style scoped="scoped" lang="less">
	.list-btn {
		margin-bottom: 20px;
	}
	.mac{
		display: flex;
		.mac-1{
			margin: 0px 20px;
		}
	}
	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/platform/alliance/mac/aisle/list.vue